import { render, staticRenderFns } from "./OperaDriverDetail.vue?vue&type=template&id=b834a42c&scoped=true&"
import script from "./OperaDriverDetail.vue?vue&type=script&lang=js&"
export * from "./OperaDriverDetail.vue?vue&type=script&lang=js&"
import style0 from "./OperaDriverDetail.vue?vue&type=style&index=0&id=b834a42c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b834a42c",
  null
  
)

export default component.exports